<template>

<div class="faq">

    <div class="faq-item">

        <div class="faq-item-question">When do I get my perks after becoming a Patreon?</div>

        <div class="faq-item-answer">
        
            <p>After pledging, log back into GeekGroup and visit your Patreon page to connect your username. This tells the site which tier you’re on and applies your perks instantly.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">I don’t want to use Patreon, can I support and get perks another way?</div>

        <div class="faq-item-answer">
        
            <p>Absolutely! The perk system is built into the website and doesn’t rely on Patreon. If you’d prefer to support via PayPal or another route, just email me at <a href="mailto:phil@geekgroup.app">phil@geekgroup.app</a> and I will help arrange it with you.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">I used the Tipjar before. Do I need to become a Patreon to keep my Tipjar perks?</div>

        <div class="faq-item-answer">
        
            <p>Nope! Those perks are permanent, you don’t need to pledge again to keep them. Thank you for supporting the site in the early years.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">Will you add more perks in the future?</div>

        <div class="faq-item-answer">
        
            <p>Yes. I plan to add perks like custom themes and more personalisation options. Core features will always remain free for everyone.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">What is a Speed Boost and how does it help?</div>

        <div class="faq-item-answer">
        
            <p>A Speed Boost makes browsing large collections or groups much faster. Behind the scenes, your data is split out into its own database, so filtering and insights don’t get slowed down by everyone else’s rows. Small collections may not notice much change, but big groups should feel the difference.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">What does Early Access mean and how long does it last?</div>

        <div class="faq-item-answer">
        
            <p>Early Access gives you finished new features (like new Insights sections) before they’re released publicly. You can use them normally and give feedback if you wish. Early Access usually lasts at least a month before the feature rolls out to all users.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">What kind of features are chosen for the Feature Voting?</div>

        <div class="faq-item-answer">
        
            <p>The monthly vote is designed to help guide development toward areas that matter most to the community. I include medium to large sized ideas that are realistic to deliver. Smaller tweaks or quick fixes usually bypass the vote and just get built. I’ll also continue to develop my own ideas in parallel.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">Can I add my own ideas to the Feature Voting?</div>

        <div class="faq-item-answer">
        
            <p>Not directly. I collect suggestions from the BGG guild forum, direct messages, and emails. Each month I review them, pick the most practical or popular ones, and put those into the voting pool.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">How long until something voted for becomes a real feature?</div>

        <div class="faq-item-answer">
        
            <p>It varies. Some features can be built and released within a month, while others may take several months depending on scope, complexity, and whether they depend on other changes. Winning a vote guarantees the feature will move up the priority list, but doesn’t always mean instant delivery.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">If my preferred option doesn’t win, is it gone forever?</div>

        <div class="faq-item-answer">
        
            <p>No. Ideas that don’t win are kept on the list and can return in future votes if they’re still relevant.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">Can my custom sub-domain be anything?</div>

        <div class="faq-item-answer">
        
            <p>Yes, you can choose almost anything, e.g. customname.geekgroup.app instead of geekgroup.app/users/name. I just need to approve it to avoid confusion with official subdomains or anything inappropriate.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">How do I connect my external domain?</div>

        <div class="faq-item-answer">
        
            <p>You will be asked to update your external domain or subdomain DNS to point to the geekgroup IP address. After that, geekgroup will handle the rest including SSL certificates.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">I don’t own a group — can I still use the group perks?</div>

        <div class="faq-item-answer">
        
            <p>Yes. You can apply Speed Boosts or Daily Group Syncs to a group you’re part of, even if you’re not the owner. The only group perk that requires ownership is the custom sub-domain.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">How do Daily Group Syncs work for groups with more than 25 members?</div>

        <div class="faq-item-answer">
        
            <p>Each Group Leader Patreon perk allows daily syncs for up to 25 members (excluding anyone who already has daily syncs). These are applied to the first 25 members who joined the group. If your group has more than 25, the rest stay on weekly updates, unless another Group Leader patreon applies their quota which stacks.</p>
        
        </div>

    </div>

    <div class="faq-item">

        <div class="faq-item-question">If I stop being a Patreon, do I keep my perks?</div>

        <div class="faq-item-answer">
        
            <p>No, perks end when your membership ends. The only exception is if you were a Tipjar supporter; you’ll always keep those original Tipjar perks.</p>
        
        </div>

    </div>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.faq-item {
    margin-bottom: 20px;
    border: 1px solid #eee;
    border-radius: 10px;
}

.is-mobile .faq-item {
    border: 0px;
    margin-bottom: 0px;
    border-bottom: 1px solid #eee;
    border-radius: 0px;
}

.faq-item-question {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: #343434;
    padding: 20px;
    border-bottom: 1px solid #eee;
}

.is-mobile .faq-item-question { 
    border-bottom: 0px;
    padding-bottom: 0px;
    padding: 20px 10px 10px 10px;
}

.faq-item-answer {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: #343434;
    padding: 20px;
}

.is-mobile .faq-item-answer {
    font-size: 12px;
    line-height: 16px;
    padding: 10px 10px 20px 10px;
}

</style>